<template>
  <div>
    <b-card
      no-body
      style="max-width: 20rem; font-family: cerebriSansReg; margin: 10px;"
      img-src="../assets/visitor_icon.svg"
      img-top
    >
      <b-card-body>
        <b-card-title>{{ form.name }}</b-card-title>
        <b-card-sub-title
          class="mb-3"
          style="text-transform: uppercase; font-size: 12px;"
        >type: {{form.type}}</b-card-sub-title>
        <b-card-text>{{ form.description }}</b-card-text>
      </b-card-body>
      <b-list-group flush>
        <b-list-group-item href="#" @click="createQR" style="text-align: center;">Create QR Code</b-list-group-item>
        <b-list-group-item style="padding-left: 0px; padding-right: 0px;">
          <b-container class="bv-example-row" style>
            <b-row cols="3">
              <b-col style="text-align: center;">
                <a href="#">
                  <img src="../assets/user_icon.svg" style="height: 30px;" />
                </a>
              </b-col>
              <b-col style="text-align: center;">
                <a href="#">
                  <img
                    src="../assets/edit_icon.svg"
                    @click="showEditProductModal"
                    style="height: 30px;"
                  />
                </a>
              </b-col>
              <b-col style="text-align: center;">
                <a href="#">
                  <img src="../assets/delete_icon.svg" @click="deleteForm" style="height: 30px;" />
                </a>
              </b-col>
            </b-row>
          </b-container>
        </b-list-group-item>
      </b-list-group>
    </b-card>
    <!--   edit product modal -->
    <div>
      <b-modal id="editProductModal" size="xl" hide-footer ref="editProductModalRef">
        <template v-slot:modal-title>Edit Form</template>
        <b-input-group>
          <template v-slot:prepend>
            <b-form-select v-model="newInputTypeSelected" :options="inputOptions"></b-form-select>
            <b-form-select v-model="newInputCheckSelected" :options="inputCheckOptions"></b-form-select>
            <b-form-select v-model="newInputInTableSelected" :options="inputInTableOptions"></b-form-select>
          </template>
          <b-form-input placeholder="Enter the title" :state="state" v-model="newInputTitle"></b-form-input>

          <template v-slot:append>
            <b-button
              v-show="state && newInputTypeSelected"
              @click="addNewInput"
              variant="outline-success"
            >Add</b-button>
          </template>
        </b-input-group>
        <hr
          style="margin-left: -15px; margin-right: -15px; border-top: 2px dashed rgba(0, 0, 0, 0.1);"
        />
        <template v-for="(input, index) in cardForm">
          <b-input-group :key="index" style="margin-top: 10px;">
            <template v-slot:prepend>
              <b-form-select v-model="input.type" :options="inputOptions"></b-form-select>
              <b-form-select v-model="input.visible" :options="inputCheckOptions"></b-form-select>
              <b-form-select v-model="input.inTable" :options="inputInTableOptions"></b-form-select>
            </template>
            <b-form-input placeholder="Enter the title" v-model="input.title"></b-form-input>
            <template v-slot:append>
              <b-button @click="deleteInput(index)" variant="outline-danger">Delete</b-button>
            </template>
          </b-input-group>
        </template>
        <b-button
          v-if="saveButtonVisible"
          @click="saveNewInputs"
          variant="outline-success"
          style="float: right; margin-top: 10px;"
        >Save</b-button>
      </b-modal>
    </div>
    <b-modal id="formQR" size="lg" hide-footer ref="formQRRef">
      <template v-slot:modal-title>Form QR</template>
      <div style="text-align: center;">
        <qriously :value="qrCode" :size="400" />
      </div>
    </b-modal>
  </div>
</template>
<script>
// Libraries
import Vue from "vue";
import VueSwal from "vue-swal";
// Functions
import { functionsDB } from "@/connection/connection.js";

Vue.use(VueSwal);

export default {
  name: "CardForm",
  props: {
    form: {},
    userJSON: {}
  },
  data() {
    return {
      cardForm: [],
      newInputTypeSelected: null,
      newInputCheckSelected: "external",
      newInputInTableSelected: false,
      newInputTitle: "",
      inputOptions: [
        { value: null, text: "Select a type" },
        { value: "text", text: "Text" },
        { value: "boolean", text: "boolean | Yes or No" }
        // { value: "options", text: "Multiple Options", disabled: true }
      ],
      inputCheckOptions: [
        { value: "external", text: "External" },
        { value: "internal", text: "Internal" }
      ],
      inputInTableOptions: [
        { value: true, text: "Shown in table" },
        { value: false, text: "Not shown in table" }
      ],
      saveButtonVisible: false,
      qrCode: ""
    };
  },
  computed: {
    state() {
      return this.newInputTitle.length >= 1 ? true : false;
    }
  },
  methods: {
    createQR() {
      var url = "";
      url = url + "https://app.umonite.com/f?"; // add domain
      // url = url + "http://192.168.1.91:8080/f?";
      url = url + `na=${encodeURIComponent(this.form.name)}&`; // add name of the form
      url = url + "id=" + this.form.id + "&"; // add id of the form
      this.form.inputs.forEach((input, index) => {
        if (input.visible == "external") {
          var inputURL = `n=${encodeURIComponent(input.title)}&`;
          var type = "";
          // property type and invisible are encoded in order to save characteres
          switch (input.type) {
            case "text":
              type = "t=1&";
              break;
            case "boolean":
              type = "t=2&";
              break;
            case "options":
              type = "t=3&";
              break;
          }
          inputURL = inputURL + type;
          url = url + inputURL;
        }
      });
      url = url.substring(0, url.length - 1); // delete last &
      this.qrCode = url;
      console.log(this.qrCode); // only for testing
      this.$refs["formQRRef"].show();
    },
    async saveNewInputs() {
      var areInputsSaved = await functionsDB.saveInputs(
        "users",
        this.userJSON.id,
        this.form.id,
        this.cardForm
      );
      if (areInputsSaved) {
        this.$refs["editProductModalRef"].hide();
        this.alertSuccess();
      } else {
        this.alertError();
      }
    },

    deleteInput(index) {
      this.cardForm.splice(index, 1);
    },

    addNewInput() {
      var newInputJSON = {
        type: this.newInputTypeSelected,
        visible: this.newInputCheckSelected,
        title: this.newInputTitle,
        inTable: this.newInputInTableSelected
      };
      this.saveButtonVisible = true;
      if (this.cardForm) {
        this.cardForm.push(newInputJSON);
      } else {
        this.cardForm = [];
        this.cardForm.push(newInputJSON);
      }
      // clean new input
      this.newInputTypeSelected = null;
      this.newInputTitle = "";
      this.newInputCheckSelected = "external";
      this.newInputInTableSelected = false;
    },

    showEditProductModal() {
      this.newInputTypeSelected = null;
      this.newInputTitle = "";
      this.newInputCheckSelected = "external";
      this.newInputInTableSelected = false;
      //this.cardForm = [];
      this.cardForm = this.form.inputs;
      this.$refs["editProductModalRef"].show();
    },

    alertSuccess() {
      this.$swal({
        title: "Perfect!",
        text: "The operation was successful.",
        icon: "success"
      });
    },

    alertError() {
      this.$swal({
        title: "Something went wrong!",
        text: "Please try again",
        icon: "error"
      });
    },

    deleteForm() {
      swal({
        title: "Are you sure?",
        text:
          "Once deleted, all access will be canceled but historical data will remain in report section.",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(async willDelete => {
        if (willDelete) {
          var isFormDeleted = await functionsDB.deleteForm(
            "users",
            this.userJSON.id,
            this.form.id
          );
          if (isFormDeleted) {
            this.alertSuccess();
          } else {
            this.alertError();
          }
        }
      });
    }
  },
  mounted() {
    this.cardForm = this.form.inputs;
    if (this.cardForm) {
      if (this.cardForm.length == 0) this.saveButtonVisible = false;
      else this.saveButtonVisible = true;
    }
  }
};
</script>